<template>
    <b-modal
        id="modal-clone-survey"
        ref="modal-clone-survey"
        centered
        ok-title="Aceptar"
        ok-variant="primary"
        cancel-title="Cancelar"
        :title="modalTitle"
        :ok-disabled="formDisabled"
        @ok="onClone"
        @hidden="resetForm()"
        @show="setForm()"
    >
        <b-form id="survey-form" @submit.stop.prevent="onSubmit()">
            <b-form-group
                id="input-group-survey-new_name"
                label="*Nombre de la copia:"
                label-for="input-survey-new_name"
            >
                <b-form-input
                    id="input-survey-new_name"
                    v-model.trim="form.newName"
                    name="survey-new_name"
                    type="text"
                    required
                    :disabled="formDisabled"
                />
            </b-form-group>
        </b-form>
        <p>
            Al aceptar se creará una copia de esta encuesta/quiz, sus preguntas y
            sus opciones con el nuevo nombre especificado.
        </p>
    </b-modal>
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
    name: 'SurveyCloneModal',
    data () {
        return {
            formDisabled: false,
            modalTitle: 'Clonar Encuesta/Quiz',
            form: {
                surveyId: null,
                newName: ''
            }
        }
    },
    computed: {
        ...mapState([
            'activeSite',
            'selectedCrudObject'
        ])
    },
    methods: {
        ...mapActions([
            'cloneSiteSurvey'
        ]),
        async onClone (bvModalEvt) {
            bvModalEvt.preventDefault() // Prevent modal from closing
            await this.onSubmit() // Trigger submit handler
        },
        setForm () {
            this.form.surveyId = this.selectedCrudObject.id
            this.form.newName = this.selectedCrudObject.name + ' Copia'
        },
        resetForm () {
            this.modalTitle = 'Agregar Nueva Encuesta/Quiz'
            this.form.surveyId = null
            this.form.newName = ''
            this.$store.commit('RESET_SELECTED_CRUD_OBJECT')
        },
        async onSubmit () {
            let loader = this.$root.$loading.show()
            try {
                this.formDisabled = true
                const payloadData = { ...this.form, courseSiteId: this.activeSite.id }
                await this.cloneSiteSurvey(payloadData)
                this.$root.successToast(`La encuesta/quiz ha sido copiada exitosamente.`)
                this.$nextTick(() => {
                    this.$bvModal.hide('modal-clone-survey')
                })
                this.resetForm()
            } catch (err) {
                console.log({ err: err })
                if (err.response && (err.response.status === 404 || err.response.status === 400)) {
                    this.$root.dangerToast('Datos incorrectos, vuelva a intentar.')
                } else {
                    this.$root.unknownErrorToast()
                }
            } finally {
                this.formDisabled = false
                loader.hide()
            }
        }
    }
}
</script>
